function setProps(obj) {
  if (Array.isArray(obj)) {
    return obj.map(setProps)
  }

  if (typeof obj !== 'object' || obj === null) return obj

  if ('component' in obj) {
    const { component, ...rawProps } = obj
    return { component, props: setProps(rawProps) }
  }

  const newObj = {}
  for (const key in obj) {
    newObj[key] = setProps(obj[key])
  }
  return newObj
}

export default setProps
